class WeightSelect extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector("select");
    this.wrap = this.closest(".product-wrap");

    if (!this.select && !this.wrap) return;

    this.updatePrice();

    this.select.addEventListener("change", this.onSelectChange.bind(this));
  }

  updateDataBox() {
    const selectedOption = this.select.options[this.select.selectedIndex];
    const multiplier = parseInt(selectedOption.getAttribute("data-multiplier")) || 2;
    const addToBoxBtn = this.wrap.querySelector(".js-add-to-box");
    if (addToBoxBtn) {
      addToBoxBtn.setAttribute("data-box", multiplier);
    }
  }

  onSelectChange(e) {
    this.value = this.select.value;
    this.url = e.target.options[e.target.selectedIndex].getAttribute("data-url");

    this.changeProductInfo(this.value, this.url);

    this.updateDataBox();
  }

  updatePrice() {
    const selectedOption = this.select.options[this.select.selectedIndex];
    let price = selectedOption.getAttribute("data-price");


    if (!price) return;

    let numericPrice = parseFloat(price.replace(/[^0-9.]/g, "")) * 100;

    const multiplier = parseInt(selectedOption.getAttribute("data-multiplier")) || 2;
    this.boxSize = multiplier;

    numericPrice = this.applyTieredDiscount(numericPrice);

    const btnPriceEl = this.wrap.querySelector(".button-atc-wrap span");
    if (btnPriceEl) {
      btnPriceEl.textContent = Shopify.formatMoney(numericPrice);
    }

    this.updateDataBox();
  }

  applyTieredDiscount(price) {
    const discount4boxes = 0.9135; // 8.65%
    if (this.boxSize === 4) {
      price = price * discount4boxes;
    }
    return price;
  }

  changeProductInfo(value, url) {
    if (this.wrap.querySelectorAll('form[data-product="' + value + '"]').length > 0) {
      this.wrap.querySelectorAll("form").forEach((form) => form.classList.add("hidden"));
      this.wrap.querySelector('form[data-product="' + value + '"]').classList.remove("hidden");
    }

    if (this.wrap.querySelectorAll('.our-range-product-review[data-product="' + value + '"]').length > 0) {
      this.wrap.querySelectorAll(".our-range-product-review").forEach((review) => review.classList.add("hidden"));
      this.wrap.querySelector('.our-range-product-review[data-product="' + value + '"]').classList.remove("hidden");
    }

    this.wrap.querySelectorAll("a:not(.our-range-product-review-href)").forEach((a) => a.setAttribute("href", url));

    this.updatePrice();

    this.updateDataBox();
  }
}

customElements.define("weight-select", WeightSelect);

window.addEventListener("pageshow", () => {
  if (document.querySelectorAll('weight-select').length > 0) {
    let checkWeight = window.location.search.includes('?weight=4kg');
    document.querySelectorAll("weight-select select").forEach((select) => {
      let index = select.getAttribute("data-index");
      if (checkWeight && select.querySelectorAll('option[data-weight="4kg"]').length > 0) {
        let option = select.querySelector('option[data-weight="4kg"]');
        index = option.getAttribute("data-index");
        
        select.selectedIndex = index;
        const weightSelect = select.closest('weight-select');
        weightSelect.changeProductInfo(select.value, option.getAttribute("data-url"));

        select.style.opacity = "1";
      } else {
        select.selectedIndex = index;
        select.style.opacity = "1";
      }
    });
  }
});

class SortFake extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector("select");
    this.selectTrigger = document.querySelector(".js-trigger-sort");

    if (!this.select && !this.selectTrigger) return;

    this.select.addEventListener("change", this.onSelectChange.bind(this));
  }

  onSelectChange() {
    this.value = this.select.value;

    this.selectTrigger.value = this.value;
    this.selectTrigger.closest("form").submit();
  }
}

customElements.define("sort-fake", SortFake);

class CollectionBanner extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    var elem = this;
    var flkty = new Flickity(elem, {
      pageDots: false,
      prevNextButtons: false,
      fade: true,
      adaptiveHeight: true,
      imagesLoaded: true
    });
  }
}

customElements.define("collection-banner", CollectionBanner);

class ProductHandtap extends HTMLElement {
  constructor() {
    super();

    this.button = this;
    this.wrap = this.button.closest('.product-wrap');

    if (!this.wrap) return;

    this.button.addEventListener("click", this.onHandleClick.bind(this));
  }

  onHandleClick(e) {
    e.preventDefault();
    
    this.wrap.classList.toggle('show-image-hover');
  }
}

customElements.define("product-handtap", ProductHandtap);

class OurRangeHighlightsDrawer extends HTMLElement {
  constructor() {
    super();

    this.panel = this.querySelector(".our-range-highlights-drawer__panel");
    this.closeButtons = this.querySelectorAll("[data-drawer-close]");
    this.sizeOptions = this.querySelectorAll("[data-size-option]");
    this.forms = this.querySelectorAll(".our-range-highlights-drawer__form");
    this.viewProduct = this.querySelector("[data-view-product]");
    this.onKeyDown = this.onKeyDown.bind(this);

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.close();
      });
    });

    this.sizeOptions.forEach((option) => {
      option.addEventListener("click", this.onSizeSelect.bind(this));
    });

    this.forms.forEach((productForm) => {
      const form = productForm.querySelector("form");
      if (!form) return;

      form.addEventListener("submit", () => {
        const submitButton = form.querySelector('[type="submit"]');
        if (!submitButton) return;

        const observer = new MutationObserver(() => {
          if (submitButton.classList.contains("loading")) return;
          observer.disconnect();
          this.close();
        });

        observer.observe(submitButton, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });
    });
  }

  open() {
    document.querySelectorAll("our-range-highlights-drawer.is-open").forEach((drawer) => {
      if (drawer !== this) drawer.close();
    });

    this.classList.add("is-open");
    document.body.classList.add("our-range-highlights-open");
    document.addEventListener("keydown", this.onKeyDown);

    if (this.panel) {
      this.panel.focus({ preventScroll: true });
    }
  }

  close() {
    this.classList.remove("is-open");
    document.body.classList.remove("our-range-highlights-open");
    document.removeEventListener("keydown", this.onKeyDown);
  }

  onKeyDown(event) {
    if (event.key === "Escape") this.close();
  }

  onSizeSelect(event) {
    const option = event.currentTarget;
    const productId = option.getAttribute("data-product-id");
    const url = option.getAttribute("data-url");

    this.sizeOptions.forEach((item) => {
      const selected = item === option;
      item.classList.toggle("is-selected", selected);
      item.setAttribute("aria-selected", selected ? "true" : "false");
    });

    this.forms.forEach((form) => {
      form.classList.toggle("hidden", form.getAttribute("data-product") !== productId);
    });

    if (this.viewProduct && url) {
      this.viewProduct.setAttribute("href", url);
    }
  }
}

customElements.define("our-range-highlights-drawer", OurRangeHighlightsDrawer);

document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-highlights-open]");
  if (!trigger) return;

  event.preventDefault();
  const drawerId = trigger.getAttribute("data-highlights-open");
  const drawer = document.getElementById(drawerId);
  if (drawer && typeof drawer.open === "function") {
    drawer.open();
  }
});